import { createFileRoute } from "@tanstack/react-router";
import { TenantList } from "@client/components/settings/tenant-management/tenant-list";

export const Route = createFileRoute("/_app/settings/tenants")({
  component: TenantList,
});
